import { ReactElement } from "react";

export class NotificacaoDto {
    id: string;
    componente: ReactElement;
    constructor(id: string, componente: ReactElement) {
        this.id = id;
        this.componente = componente;
    }
}